import React from "react";
import { useQuery } from "react-query";
import { ExportJob } from "types";
import { api } from "../../api/api";
import { ExportJobModal } from "../Common/ExportJobModal";

interface ExportTicketsModalProps {
    isOpen: boolean;
    onClose: () => void;
    id: ID;
}

export const ExportTicketsModal = ({ isOpen, onClose, id }: ExportTicketsModalProps) => {
    return <ModalContent isOpen={isOpen} id={id} onClose={onClose} />;
};

const ModalContent = ({ isOpen, onClose, id }: ExportTicketsModalProps) => {
    const { data: job } = useQuery<ExportJob>(
        ["purchases", "jobs", id],
        async () => {
            const { data } = await api.get<ExportJob>(`/purchases/${id}`, {
                params: { context: "tickets", format: "xlsx" },
            });
            return data;
        },
        { enabled: isOpen, staleTime: 0 },
    );

    return job ? <ExportJobModal isOpen={isOpen} job={job} onClose={onClose} /> : null;
};
